var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaceholder4By3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 475,
    viewBox: "0 0 900 475",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 899.713,
    height: 475,
    fill: "#F5F4F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M503.93 203.341C505.45 201.825 507.409 200.825 509.529 200.483C511.648 200.142 513.822 200.475 515.741 201.437L613.529 282.234V374.352C613.529 379.781 611.373 384.988 607.534 388.827C603.695 392.666 598.488 394.823 593.059 394.823H306.471C301.041 394.823 295.835 392.666 291.996 388.827C288.157 384.988 286 379.781 286 374.352V333.411L360.636 244.282C362.309 242.615 364.507 241.578 366.858 241.347C369.208 241.115 371.566 241.704 373.532 243.013L427.984 299.778L503.93 203.361V203.341Z",
    fill: "#DBD8E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M378.078 176.353C391.651 176.353 404.668 170.961 414.265 161.364C423.863 151.766 429.254 138.749 429.254 125.176C429.254 111.604 423.863 98.5867 414.265 88.9892C404.668 79.3918 391.651 74 378.078 74C364.505 74 351.488 79.3918 341.891 88.9892C332.293 98.5867 326.901 111.604 326.901 125.176C326.901 138.749 332.293 151.766 341.891 161.364C351.488 170.961 364.505 176.353 378.078 176.353V176.353Z",
    fill: "#DBD8E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder4By3);
export default __webpack_public_path__ + "static/media/placeholder-4by3.a8dcc94e55c9dbff09dbffb8fe74c632.svg";
export { ForwardRef as ReactComponent };